import * as React from 'react'
import styled from 'styled-components'
import BackgroundGradient from '@components/BackgroundGradient'
import { CTAPrimaryLink } from '@components/shared'
import { config, Container } from 'react-awesome-styled-grid'
import { colors } from '../shared/colors'
import { useSelector } from 'react-redux'
import type { AppStateType } from '@reducers/appstate'
import { useSearchParams } from 'next/navigation'

export default function UnlockBanner (): React.ReactNode {
  const subscriptionCta = useSelector((state: AppStateType): string => state.subscriptionCTA)
  const searchParams = useSearchParams()

  // Get promo from URL params, default to 'try7d'
  const promo = searchParams.get('promo') || 'try7d'

  // Build URL params object
  const params = new URLSearchParams()
  params.set('promo', promo)
  params.set('f', '2')

  // Preserve UTM parameters
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
  utmParams.forEach((utmParam: string): void => {
    const value = searchParams.get(utmParam)
    if (value) {
      params.set(utmParam, value)
    }
  })

  // Construct subscribe URL
  const subscribeUrl = `/subscribe?${params.toString()}`

  return (
    <Banner>
      <ImageContainer>
        <BackgroundGradient
          quadrant={3}
          overlayColor='magenta'
        />
      </ImageContainer>

      <Container>
        <Content>
          <TextContainer>
            <Header>Unlock 1,000+ spicy stories</Header>
            <SubHeader>Get the full experience with a free trial.</SubHeader>
          </TextContainer>

          <OrangePill className={'subscribe-cta'} href={subscribeUrl}>
              <SmallText>TRY FOR FREE</SmallText>
              <LargeText>{subscriptionCta}</LargeText>
          </OrangePill>
        </Content>
      </Container>
    </Banner>
  )
}
const Banner = styled.div<any>`
  display: flex;
  height: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1;
`
const ImageContainer = styled.div<any>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`
const Content = styled.div<any>`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: space-between;
  gap: .5rem;
`
const TextContainer = styled.div<any>`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  ${(props: any): any => config(props).media.md`
    align-items: center;
  `}
`
const SubHeader = styled.p<any>`
  color: ${colors.white};
  font-family: "Good Sans Light";
  font-size: 12px;
  font-style: normal;
  font-weight: normal;
  line-height: 130%;
  margin: 0;
  padding: 0;
  ${(props: any): any => config(props).media.md`
    font-size: 14px;
  `}
  ${(props: any): any => config(props).media.lg`
    font-size: 16px;
  `}
  @media only screen and (max-width: 400px) {
    display: none;
  }
`
const Header = styled(SubHeader)<any>`
  display: block;
  font-family: "Good Sans Bold";
  margin-right: .5rem;
  ${(props: any): any => config(props).media.md`
    ::after {
      content: ".";
    }
  `}
`
const SmallText = styled.span<any>`
  display: inline;
  ${(props: any): any => config(props).media.md`
    display: none;
  `}
`
const LargeText = styled.span<any>`
  display: none;
  ${(props: any): any => config(props).media.md`
    display: inline;
  `}
`
const OrangePill = styled(CTAPrimaryLink)<any>`
  border-radius: 13px;
  height: 26px;
  line-height: 100%;
  min-width: unset;
  padding: 0 12px;
  font-size: 10px;
  white-space: nowrap;
  z-index: 1;
  ${(props: any): any => config(props).media.md`
    border-radius: 20px;
    height: 40px;
    padding: 0 20px;
    font-size: 12px;
  `}
`
